import { ToolStates } from './ToolStates';
import { NavigationStates } from './NavigationStates';
import { SwitchingState } from './SwitchingState';
import { ToolCategoryState } from './ToolCategoryState';
import { NotifState } from './NotifState';
import { ActionStates } from './ActionState';
import { AdminState } from './AdminState';
import { Service } from './Service';
import { ArrouseState } from './ArrouseState';
import { ReportState } from './ReportState';
import { ProductState } from './ProductState';
import { RetainState } from './RetainState';
import { SiteStates } from './SiteState';
import { UbrState } from './UbrState';
import { MaintenanceState } from './MaintenanceState';
import { DashboardState } from './DashboardState';
import { DeliveryState } from './DeliveryState';
import { SalesPage } from './SalesPage';
import { Payment } from './Payment';
import { Call } from './CallState';
import { RealProperty } from './RealProperty';
import { Personalization } from './Personalization';
import { Website } from './Website';
import { WebSiteNavState } from './WebSiteNav';
import { ReviewsRatings } from './ReviewsRatings'
import { SocialMediaInsight } from './SocialMediaInsight'
import { Setup } from './Setup';
import { MarketingCamp } from './MarketingCamp';
import { SalesRevenueState } from './SalesRevenueState';

export const Context = () => {
    return {
        tool_state: ToolStates(),
        navigation_state: NavigationStates(),
        switching_state: SwitchingState(),
        tool_category_state: ToolCategoryState(),
        notif_state: NotifState(),
        admin_state:AdminState(),
        service_state: Service(),
        site_state: SiteStates(),
        action_state: ActionStates(),
        arouse_state: ArrouseState(),
        retain_state:RetainState(),
        report_state:ReportState(),
        product_state:ProductState(),     
        ubr_state:UbrState(),     
        maintenance_state: MaintenanceState(),
        dashboard_state: DashboardState(),
        delivery_state: DeliveryState(),
        salespage_state: SalesPage(),
        payment_state: Payment(),
        call_state: Call(),
        realproperty_state: RealProperty(),
        personalization_state: Personalization(),
        website_state: Website(),
        website_nav_state: WebSiteNavState(),
        reviews_state: ReviewsRatings(),
        social_media_insight_state: SocialMediaInsight(),
        setup_state: Setup(),
        // marketing campaign state
        marketing_camp: MarketingCamp(),
		// sales revenue state
		sales_revenue: SalesRevenueState(),
    }
}